<template>
    <div class="row justify-content-center">
        <div class="col-md-12">
            <Loading v-if="showLoading" />
            <div class="card mb-3 py-3 px-3">
                <div class="row">
                    <div class="col-md-3">
                        <form v-on:submit.prevent="searchFidaCode">
                            <label for="fida-code">کد فیدا </label>
                            <div class="input-group">
                                <input class="form-control text-left"  id="fida-code" type="tel" v-model="fidaCode">
                                <span class="input-group-btn"><button class="btn ripple btn-primary" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                            </div>
                        </form>
                    </div>
                </div>
                 <hr  v-if="person"/> 
                <div class="row" v-if="person">
                    <div class="col-6 px-2 py-1 border-0">
                        <div class="table-responsive">
                            <table class="table main-table-reference text-nowrap my-0">
                                <tbody>
                                    <tr>
                                        <td class="bg-gray-100" width="40%"><b>
                                                نام</b></td>
                                        <td><b>{{ person.PersianFirstName || "-" }}</b></td>
                                    </tr>
                                    <tr>
                                        <td class="bg-gray-100"><b>
                                                نام خانوادگی </b></td>
                                        <td> <b>
                                                {{ person.PersianLastName || "-" }}
                                            </b></td>
                                    </tr>
                                    <tr>
                                        <td class="bg-gray-100"><b>
                                                جنسیت </b></td>
                                        <td><b>
                                                {{ person.Gender || "-" }}
                                            </b> </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-6 px-2  py-1 border-0">
                        <div class="table-responsive">
                            <table class="table main-table-reference text-nowrap my-0">
                                <tbody>
                                      <tr>
                                        <td class="bg-gray-100"><b>نام و نام خانوادگی به لاتین </b>
                                        </td>
                                        <td><b v-if=" person.LatinFirstName || person.LatinLastName">
                                                {{ person.LatinFirstName || "" }}  {{ person.LatinLastName ||"" }}
                                            </b>
                                            <b v-else > - </b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="bg-gray-100" width="40%"><b> نام اجداد
                                            </b></td>
                                        <td><b>
                                                {{ person.AncestorName || "-" }}
                                            </b> </td>
                                    </tr>
                                    <tr>
                                        <td class="bg-gray-100"><b> نام پدر </b>
                                        </td>
                                        <td><b>
                                                {{ person.PersianFatherName || "-" }}
                                            </b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="col-6 px-2  border-0 py-1">
                        <div class="table-responsive">
                            <table class="table main-table-reference text-nowrap my-0">
                                <tbody>
                                    <tr>
                                        <td class="bg-gray-100" width="40%"><b>
                                                ملیت </b></td>
                                        <td><b >
                                                {{ person.Nationality || "-" }}
                                            </b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="bg-gray-100"><b> کشور محل تولد </b>
                                        </td>
                                        <td>
                                            <b >
                                                {{ person.BirthPlaceCountry || "-"}}
                                            </b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="bg-gray-100"><b> تایخ تولد </b>
                                        </td>
                                        <td>
                                            <b >
                                                {{ person.PersianBirthDate || "-"}}
                                            </b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-if="person.DocumentTitle" class="col-6 px-2  border-0 py-1">
                        <div class="table-responsive">
                            <table class="table main-table-reference text-nowrap my-0">
                                        <tbody>
                                            <tr>
                                                <td class="bg-gray-100" width="40%">
                                                    <b> نوع مدرک </b>
                                                </td>
                                                <td><b >
                                                        {{person.DocumentTitle  || "-"}}
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100">
                                                    <b> شماره {{ person.DocumentTitle }} </b>
                                                </td>
                                                <td> <b >
                                                        {{ person.DocumentNumber || "-" }}
                                                    </b>
                                                
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100"><b> تاریخ اعتبار {{person.DocumentTitle   }} </b>
                                                </td>
                                                <td>
                                                    <span>از </span>
                                                    <b >  {{ person.DocumentIssueDate || "-" }}</b>
                                                  <span> تا </span>
                                                    <b >  {{ person.DocumentExpirationDate || "-" }}</b>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InquiryFidaCode',
    data(){
        return {
            showLoading: false,
            fidaCode: '',
            person : null
        }
    },
    methods: {
        searchFidaCode(){
            this.showLoading = true;
            this.$api.post(`Fida/InquiryFidaCode` , {foreignCode: this.fidaCode }).then(({ data }) => {
                if(data.status){
                    this.person = data.result
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
    }
}
</script>